import React, { useState } from 'react';

import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import { TableRow, TableCell, IconButton } from '@mui/material';
import { RiPencilLine, RiDeleteBinLine } from 'react-icons/ri';
import DeleteCarrierDialog from '../DeleteCarrierDialog';

import { Carrier } from 'common/types';
import { push, Routes } from 'routing';

interface Props {
	row: Carrier;
}

const CarrierRow = ({ row }: Props) => {
	const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);

	const classes = useStyles();

	const renderNameCell = () => <TableCell className={classes.nameCell}>{row.name.def}</TableCell>;

	const renderActionsCell = () => (
		<TableCell className={classes.fitContent}>
			<IconButton
				size="small"
				className={classes.icon}
				onClick={() => push(Routes.SingleCarrier(row.id))}
			>
				<RiPencilLine />
			</IconButton>
			<IconButton size="small" className={classes.icon} onClick={() => setDeleteDialogOpen(true)}>
				<RiDeleteBinLine />
			</IconButton>
		</TableCell>
	);

	return (
		<>
			<TableRow className={classes.tableRow}>
				{renderNameCell()}
				{/*
				*
				Hidden at the moment since we don't give the user the option to change the location for a carrier.
				- Axel 24th of June 2021
				*
				renderLocationsCell()
				*
				*/}
				{renderActionsCell()}
			</TableRow>
			<DeleteCarrierDialog
				value={row}
				open={deleteDialogOpen}
				onClose={() => setDeleteDialogOpen(false)}
			/>
		</>
	);
};

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		tableRow: {
			'& > *': {
				borderBottom: '1px solid #d8d8d8',
				verticalAlign: 'baseline',
				'&:first-child': {
					paddingLeft: theme.spacing(4),
				},
			},
		},
		nameCell: {
			minWidth: 130,
		},
		locationCell: {
			minWidth: 150,
		},
		fitContent: {
			whiteSpace: 'nowrap',
			width: '1%',
		},
		icon: {
			'&:last-child': {
				marginLeft: theme.spacing(1),
			},
		},
	}),
);

export default CarrierRow;
